module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-7-svgrepo-com.07717aee.svg";